import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCubeFront = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.21526 0H3.94775L3.80519 0.213842C3.80096 0.219898 3.79686 0.226051 3.79289 0.232299L0.0876514 5.79018L0.0797824 5.80198L0 5.92165V6H-4.95911e-05V14H0V14.0038H0.5H10.7172H11.0262L11.1644 13.7274L13.9509 8.15433L14.0037 8.04875V7.93072V0.5V0H13.5037H4.21535H4.21526ZM1.43425 5.57305L3.92541 1.8363C4.00717 1.89457 4.10721 1.92884 4.21526 1.92884C4.4914 1.92884 4.71526 1.70498 4.71526 1.42884V1H12.6947L10.4082 5.57305H4.47249C4.61795 5.48561 4.71526 5.32627 4.71526 5.1442V3.28652C4.71526 3.01038 4.4914 2.78652 4.21526 2.78652C3.93912 2.78652 3.71526 3.01038 3.71526 3.28652V5.1442C3.71526 5.32627 3.81258 5.48561 3.95803 5.57305H1.43425ZM11.2172 6.19107L13.0037 2.61804V7.43072H11.9362C11.6601 7.43072 11.4362 7.65458 11.4362 7.93072C11.4362 8.20686 11.6601 8.43072 11.9362 8.43072H12.6947L11.2172 11.3857V6.19107Z",
		fill: "white"
	})]
});
export default SvgCubeFront;
